import type { FC } from 'react';

import classNames from 'classnames';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { isLiveAsset } from '@iconik-io/shared-lib/src/utils/is_live_asset';
import { Icon } from '@iconik-io/uad';

import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from '../asset_status_icon_detailed.module.css';

const WarningStatuses: FC<{
  object: SearchItemEntity;
  expandedPod: boolean;
}> = ({ object, expandedPod }) => {
  const statuses = [];

  // A growing asset reads as offline only because its file has yet to close, and
  // the LIVE chip already says what is happening
  if (
    object.is_online === false &&
    object.type === 'ASSET' &&
    !isLiveAsset(object)
  ) {
    statuses.push(
      <TooltipTrigger
        key="offline-status"
        tooltipText="This asset is offline"
        placement="bottom"
        componentProps={{
          role: 'status',
          'aria-label': 'This asset is offline',
        }}
      >
        <div className={styles.status_icon}>
          <Icon name="message_error" />
        </div>
      </TooltipTrigger>,
    );
  }

  if (expandedPod) {
    statuses.push(
      <TooltipTrigger
        tooltipText="Metadata warning"
        placement="bottom"
        key="Metadata warning"
        componentProps={{
          role: 'status',
          'aria-label': 'Metadata warning',
        }}
      >
        <div className={styles.status_icon}>
          <Icon name="message_warning" />
        </div>
      </TooltipTrigger>,
    );
  }

  if (object.is_blocked) {
    statuses.push(
      <TooltipTrigger
        tooltipText="Asset is locked"
        key="asset-locked-status"
        placement="bottom"
        componentProps={{
          role: 'status',
          'aria-label': 'Asset is locked',
        }}
      >
        <div className={styles.status_icon}>
          <Icon name="padlock_locked" />
        </div>
      </TooltipTrigger>,
    );
  }

  if (object.face_recognition_status === 'IN_PROGRESS') {
    statuses.push(
      <TooltipTrigger
        tooltipText="Face recognition in progress"
        key="face-recognition-in-progress-status"
        placement="bottom"
        componentProps={{
          role: 'status',
          'aria-label': 'Face recognition in progress',
        }}
      >
        <div className={styles.status_icon}>
          <Icon name="face_recognition" />
        </div>
      </TooltipTrigger>,
    );
  }

  if (object.analyze_status === 'IN_PROGRESS') {
    statuses.push(
      <TooltipTrigger
        tooltipText="Analyze in progress"
        key="analyze-progress-status"
        placement="bottom"
        componentProps={{
          role: 'status',
          'aria-label': 'Analyze in progress',
        }}
      >
        <div className={styles.status_icon}>
          <Icon name="analyze" />
        </div>
      </TooltipTrigger>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_warning, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};

export default WarningStatuses;
